<template>
  <div id="div-with-loading" class="vs-con-loading__container img-bg">

    <!-- LOGO -->
    <!-- <vs-row vs-w="12">
      <vs-col vs-xs="12" vs-sm="12">
        <vs-card style="padding: 0px" class="roundedCard card-inline">
          <img src="@/assets/images/asset-world/asset-world-logo.png" alt="Asset World LOGO" />
        </vs-card>
      </vs-col>
    </vs-row> -->

    <vs-row vs-w="12">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6">

        <vs-row vs-w="12">
          <vs-col class="px-0" vs-xs="12" vs-sm="12" vs-lg="12">
            <vs-card class="roundedCard card-total-customized" style="position: relative;">
            <vs-row vs-w="12">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="text-center">
                  <p class="card-title" style="font-size: 30px; font-weight: bold;">Total Power Consumption</p>
                  <p class="card-title-value">{{ new Intl.NumberFormat().format(datas.totalPowerConsumption.total) }} <span>kWh</span></p>
                </vs-col>
              </vs-row>
              <vs-row vs-w="12">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="5" >
                  <img class="mb-5" style="width: 100%;" src="@/assets/images/asset-world/electric-meter.png" />
                </vs-col>

                <vs-col vs-xs="12" vs-sm="12" vs-lg="7">
                  <!-- <p class="card-title" style="font-size: 30px; font-weight: bold;">Total Power Consumption</p>
                  <p class="card-title-value">{{ new Intl.NumberFormat().format(datas.totalPowerConsumption.total) }} <span>kWh</span></p> -->

                  <p class="card-volume-1 text-right">Daily Volume:
                    <span>{{ new Intl.NumberFormat().format(datas.totalPowerConsumption.dailyVolume) }}</span> kWh
                  </p>
                  <p class="card-volume-1 text-right">Daily Peak:
                    <span>{{ new Intl.NumberFormat().format(datas.totalPowerConsumption.dailyPeak) }}</span> kWh
                  </p>
                  <p class="card-volume-1 text-right">Daily (PF):
                    <span>{{ new Intl.NumberFormat().format(datas.totalPowerConsumption.dailyPF) }}</span> PF
                  </p>

                  <p class="card-volume-1 text-right">Monthly Volume:
                    <span>{{ new Intl.NumberFormat().format(datas.totalPowerConsumption.monthVolume) }}</span> kWh
                  </p>
                  <p class="card-volume-1 text-right">Yearly Volume:
                    <span>{{ new Intl.NumberFormat().format(datas.totalPowerConsumption.yearVolume) }}</span> kWh
                  </p>

                  <p class="card-date text-right">{{ datas.totalPowerConsumption.date }}</p>
                </vs-col>
              </vs-row>
            </vs-card>
          </vs-col>
        </vs-row>

        <!-- Only Content (Below Map Row) -->
        <!-- <vs-row>
          <vs-col class="pl-0" vs-xs="12" vs-sm="12" vs-lg="6">
            <vs-card class="roundedCard text-center">
              <div class="simple-box">
                <div>
                  <p class="card-title">Power Consumption</p>
                  <p class="card-value">{{ datas.powerConsumptionTotal }}</p>
                </div>
              </div>
            </vs-card>
          </vs-col>

          <vs-col class="pr-0" vs-xs="12" vs-sm="12" vs-lg="6">
            <vs-card class="roundedCard text-center ">
              <div class="simple-box">
                <div>
                  <p class="card-title">Power Active</p>
                  <p class="card-value">{{ datas.powerConsumptionActive }}</p>
                </div>
              </div>
            </vs-card>
          </vs-col>
        </vs-row> -->
      </vs-col>

      <!-- Chart Columm -->
      <vs-col vs-xs="12" vs-sm="12" vs-lg="6">
        <vs-row>
          <vs-card class="roundedCard pt-4">
            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
              <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                <chart style="width: 100%" :text="'Power Volume (kWh)'" colorgraph="#EF9BD8" :unit="' kWh'" :heightgrapg="200"
                  :datasets3="datas.powerVolume" />
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-row>

        <vs-row>
          <vs-card class="roundedCard pt-4">
            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
              <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                <chart style="width: 100%" :text="'Power Factor'" :unit="' PF'" colorgraph="#b85bff" :heightgrapg="200"
                  :datasets3="datas.powerFactor" />
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-row>

      </vs-col>
    </vs-row>

    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
        <vs-card class="roundedCard pt-4">
          <chartbar :text="'Power Consumption Graph'" :colorgraph="borderColorP" :heightgrapg="160" :fontcolor="'white'"
            :datasets3="datas.powerConsumption" />
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-row vs-w="12">
      <vs-col vs-xs="12" vs-sm="12" vs-lg="4">
        <vs-card class="roundedCard pt-4" style="height: 489px;">
          <div v-for="epData in datas.electricPotential" :key="epData.key" style="display: flex; align-items: center">
            <div style="width: 100%">
              <ul class="list-none" align="center">
                <li>
                  <h4 :class="'textlist2 gradient' + epData.key">Data Phase {{ epData.key }}</h4>
                </li>
                <li class="mt-3">
                  <h4>
                    <b style="font-weight: 600; color: #ecb314">Volt</b>
                    <b class="ml-2 mr-2" style="font-weight: 600">
                      {{
                          epData.volume > 10000
                            ? parseFloat(epData.volume / 100).toFixed(2)
                            : parseFloat(epData.volume).toFixed(2)
                      }}</b>V
                  </h4>
                </li>

                <li class="mt-3">
                  <h4>
                    <b style="font-weight: 600; color: #866ed6">Amps</b>
                    <b class="ml-2 mr-2" style="font-weight: 600">
                      {{ parseFloat(epData.current).toFixed(2) }}</b>A
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </vs-card>
      </vs-col>

      <vs-col vs-xs="12" vs-sm="12" vs-lg="8">
        <vs-card class="roundedCard pt-4">
          <h2 class="px-3" style="font-weight: 600">
            Electric Potential Graph
          </h2>
          <StockChart :chart="StockChartCom" />
        </vs-card>
      </vs-col>
    </vs-row>

    <b-modal id="modal-settingColum" hide-header centered size="lg">
      <h4 class="mb-4 colorSuccess" style="font-size: 1.125rem; font-weigth: 500">
        Sensor List Settings
      </h4>
      <span>Select Parameter</span>
      <vs-row vs-w="12">
        <vs-col :disabled="visibleFields.length == 1 && field.visible" v-for="field in fields" :key="field.key"
          style="padding: 0" vs-type="flex" vs-align="center" vs-lg="4" class="mt-3" vs-sm="4" vs-xs="12">
          <vs-checkbox class="col-checkbox" v-model="field.visible">
            {{ field.label }}</vs-checkbox>
        </vs-col>
      </vs-row>

      <template #modal-footer>
        <vs-button class="brdbtn" color="success" type="filled">Submit</vs-button>
        <vs-button class="brdbtn" color="dark" type="flat">Cancel</vs-button>
      </template>
    </b-modal>

    <b-modal scrollable id="modal-settingMap" ref="settingMap" no-close-on-backdrop="false" hide-header centered
      size="lg">
      <h4 class="mb-4 colorSuccess" style="font-size: 1.125rem; font-weigth: 500">
        Map Settings
      </h4>
      <br />
      <vs-row vs-w="12">
        <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
          <div class="img-wraps">
            <span style="width: 22%; height: 25%" :class="i.class" v-for="i in filteredList" :key="i">
              <img v-if="i.type == select1" style="width: 100%; height: 100%" src="@/assets/icon/black.png" />
              <img v-if="select1 == 'Custom'" style="width: 100%; height: 100%" src="@/assets/icon/black.png" />
              <img v-if="select1 == 'Default'" style="width: 100%; height: 100%" src="@/assets/icon/black.png" />
            </span>
            <img class="imgMapFreacer" src="@/assets/images/Freacer/undraw_product_iteration_kjok.png" />
          </div>
        </vs-col>
        <vs-col class="mt-4" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <div>
            <vs-select class="mb-4 mt-2" width="300px" label="Select Location" v-model="select1">
              <vs-select-item :key="index" :value="item.text" :text="item.text" v-for="(item, index) in optionsMap" />
            </vs-select>
            <vs-select v-if="['Custom'].includes(select1)" class="mb-4 mt-2" width="300px" multiple
              label="Select Location" v-model="selectLocation">
              <vs-select-item :key="index" :value="item.text" :text="item.text" v-for="(item, index) in optionsMap2" />
            </vs-select>
            <vs-select v-if="
              ['Custom'].includes(select1) &&
              selectLocation.includes('Inside')
            " class="mb-4 mt-2" width="300px" multiple label="Select Device Hight" v-model="selectHeightMap">
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="(item, index) in optionsHeight" />
            </vs-select>
            <vs-select v-if="
              ['Custom'].includes(select1) &&
              selectLocation.includes('Outside')
            " class="mb-4 mt-2" width="300px" multiple label="Select Device Hight" v-model="selectAreaMap">
              <vs-select-item :key="index" :value="item.text" :text="item.text"
                v-for="(item, index) in optionsHeightOutside" />
            </vs-select>
            <vs-select v-if="['Custom'].includes(select1)" width="300px" class="mb-4 mt-2" label="Select device"
              label-placeholder="Multiple" multiple v-model="selectDevice">
              <vs-select-item :key="index" :value="item.id" :text="item.name"
                v-for="(item, index) in filterSelectDevice" />
            </vs-select>
            <span class="mb-2" style="
                font-size: 0.85rem;
                padding-left: 5px;
                color: rgba(0, 0, 0, 0.6);
              ">Select Color Rulse</span>
            <vs-row class="mb-3 mt-3" v-for="i in optionsColor" :key="i" vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="3">
                <span :class="i.color">{{ i.text }}</span>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="2">
                <input v-if="i.value1" type="”number”" style="
                    width: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 0.4rem;
                  " v-model="i.value1" />
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="1">
                {{ i.icon }}
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="2">
                <input type="”number”" style="
                    width: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 0.4rem;
                  " v-model="i.value2" />
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
      <template #modal-footer>
        <vs-button class="brdbtn" color="success" @click="
          saveMapsetting(
            optionsColor,
            select1,
            selectHeightMap,
            selectDevice,
            selectAreaMap,
            selectLocation,
            filteredList
          )
        " type="filled">Submit</vs-button>
        <vs-button class="brdbtn" color="dark" @click="cancelMapsetting" type="flat">Cancel</vs-button>
      </template>
    </b-modal>

    <vs-popup button-close-hidden fullscreen title="Map Settings" :active.sync="popupActivo4"><br />
      <!-- <pre>{{filteredList}}</pre> -->
      <vs-row vs-w="12">
        <vs-col style="text-align: center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div class="img-wraps">
            <span style="width: 22%; height: 25%" :class="i.class" v-for="i in filteredList" :key="i">
              <img v-if="i.type == select1" style="width: 100%; height: 100%" src="@/assets/icon/black.png" />
              <img v-if="select1 == 'Custom'" style="width: 100%; height: 100%" src="@/assets/icon/black.png" />
              <img v-if="select1 == 'Default'" style="width: 100%; height: 100%" src="@/assets/icon/black.png" />
            </span>
            <img class="imgMapFreacer" src="@/assets/images/Freacer/undraw_product_iteration_kjok.png" />
          </div>
          <br /><br />
          <vs-row class="mb-1">
            <vs-spacer />
          </vs-row>
          <vs-row v-if="['Inside'].includes(select1)">
            <vs-spacer />
            <p class="mr-2" style="font-size: 0.85rem; color: rgba(0, 0, 0, 0.6)">
              Select Height :
            </p>
            <div v-for="i in optionsHeight" :key="i">
              <vs-radio v-model="btnHeigth" class="mr-2" vs-name="radios1" @click="search(i.value)" :vs-value="i.value">
                {{ i.text }}</vs-radio>
            </div>
          </vs-row>
        </vs-col>
        <vs-col class="mt-4" vs-type="flex" vs-lg="6" vs-sm="12" vs-xs="12">
          <div>
            <vs-select class="mb-4 mt-2" width="300px" label="Select Mode" v-model="select1">
              <vs-select-item :key="index" :value="item.text" :text="item.text" v-for="(item, index) in optionsMap" />
            </vs-select>
            <vs-select v-if="['Custom'].includes(select1)" class="mb-4 mt-2" width="300px" multiple
              label="Select Location" v-model="selectLocation">
              <vs-select-item :key="index" :value="item.text" :text="item.text" v-for="(item, index) in optionsMap2" />
            </vs-select>
            <vs-select v-if="
              ['Custom'].includes(select1) &&
              selectLocation.includes('Outside')
            " class="mb-4 mt-2" width="300px" multiple label="Select Device Area" v-model="selectAreaMap">
              <vs-select-item :key="index" :value="item.text" :text="item.text"
                v-for="(item, index) in optionsHeightOutside" />
            </vs-select>
            <vs-select v-if="
              ['Custom'].includes(select1) &&
              selectLocation.includes('Inside')
            " class="mb-4 mt-2" width="300px" multiple label="Select Device Height" v-model="selectHeightMap">
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="(item, index) in optionsHeight2" />
            </vs-select>
            <vs-select v-if="['Custom'].includes(select1)" width="300px" class="mb-4 mt-2" label="Select Device"
              label-placeholder="Multiple" multiple v-model="selectDevice">
              <vs-select-item :key="index" :value="item.id" :text="item.name"
                v-for="(item, index) in filterSelectDevice" />
            </vs-select>

            <span class="mb-2" style="
                font-size: 0.85rem;
                padding-left: 5px;
                color: rgba(0, 0, 0, 0.6);
              ">Select Color Rulse</span>
            <vs-row class="mb-3 mt-3" v-for="i in optionsColor" :key="i" vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="3">
                <span :class="i.color">{{ i.text }}</span>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="2">
                <input v-if="i.value1" type="”number”" style="
                    width: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 0.4rem;
                  " v-model="i.value1" />
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="1">
                {{ i.icon }}
              </vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="2">
                <input type="”number”" style="
                    width: 100%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 0.4rem;
                  " v-model="i.value2" />
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
      <br />
      <vs-row>
        <vs-spacer />
        <vs-button class="brdbtn mr-1" color="success" @click="
          saveMapsetting(
            optionsColor,
            select1,
            selectHeightMap,
            selectDevice,
            selectAreaMap,
            selectLocation,
            filteredList,
            btnHeigth
          )
        " type="filled">Submit</vs-button>
        <vs-button class="brdbtn" color="dark" @click="cancelMapsetting" type="flat">Cancel</vs-button>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import MiniChart from "./MiniChart.vue";
import moment from "moment";
import { Datetime } from "vue-datetime";
import chart from "../dashboard/Ajinomoto/dashboard/chart.vue";
import chartbar from "../dashboard/Ajinomoto/dashboard/chartbar.vue";
import StockChart from "@/components/HighChart/StockChart.vue";

export default {
  name: "CustomDashboard",
  components: {
    // moment,
    chart,
    chartbar,
    MiniChart,
    StockChart,
    datetime: Datetime,
  },
  data: () => ({
    id: 0,
    datas: {
      powerConsumptionTotal: 0,
      powerConsumptionActive: 86.04,
      totalPowerConsumption: {
        total: 0,
        yearVolume: 0,
        monthVolume: 0,
        dailyVolume: 0,
        dailyPeak: 0,
        dailyPF: 0,
        date: moment().format('DD/MM/YYYY HH:mm'),
      },
      electricPotentialChart: {
        chart: {
          backgroundColor: "transparent",
        },
        xAxis: {
          type: 'datetime'
        },
        rangeSelector: {
          buttons: [
            {
              type: "hour",
              count: 3,
              text: "3h",
            },
            {
              type: "hour",
              count: 6,
              text: "6h",
            },
            {
              type: "hour",
              count: 12,
              text: "12h",
            },
            {
              type: "day",
              count: 1,
              text: "1D",
            },
            {
              type: "all",
              count: 1,
              text: "All",
            },
          ],
          selected: 1,
          // inputEnabled: false
        },
        colors: ["#cc7400", "#00cc7e", "#da2acb"],
        title: {
          // text: "Vibration Sensor Graph",
          align: "left",
          style: {
            color: "var(--text-color-2)",
            fontSize: "18px",
            "font-weight": "900",
          },
        },
        series: [],
      }
    }, // API Data
    dataP: "",
    chart_Data_inside: {
      datasets: [
        {
          data: [],
          label: "Temperature ( °C )",
          borderWidth: 1.5,
          backgroundColor: "rgba(172, 0, 252,.1)",
          borderColor: "rgba(172, 0, 252,.9)",
          //     backgroundColor:  this.gradient,
        },
        {
          data: [],
          label: "Humid ( % )",
          backgroundColor: "rgba(20, 153, 242,.1)",
          borderWidth: 1.5,
          borderColor: "rgba(20, 153, 242,.9)",

          //     backgroundColor:  this.gradient,
        },
      ],
      labels: [],
    },
    powerVolumeChart: {
      "day": [
        {
          "volume": 78,
          "time": "2022-11-08 4PM"
        },
        {
          "volume": 1721,
          "time": "2022-11-08 3PM"
        },
        {
          "volume": 1693,
          "time": "2022-11-08 2PM"
        },
        {
          "volume": 1569,
          "time": "2022-11-08 1PM"
        },
        {
          "volume": 1285,
          "time": "2022-11-08 12PM"
        },
        {
          "volume": 1424,
          "time": "2022-11-08 11AM"
        },
        {
          "volume": 1498,
          "time": "2022-11-08 10AM"
        },
        {
          "volume": 1573,
          "time": "2022-11-08 9AM"
        },
        {
          "volume": 1659,
          "time": "2022-11-08 8AM"
        },
        {
          "volume": 1346,
          "time": "2022-11-08 7AM"
        },
        {
          "volume": 1407,
          "time": "2022-11-08 6AM"
        },
        {
          "volume": 1491,
          "time": "2022-11-08 5AM"
        },
        {
          "volume": 1336,
          "time": "2022-11-08 4AM"
        },
        {
          "volume": 1434,
          "time": "2022-11-08 3AM"
        },
        {
          "volume": 1442,
          "time": "2022-11-08 2AM"
        },
        {
          "volume": 1504,
          "time": "2022-11-08 1AM"
        },
        {
          "volume": 1540,
          "time": "2022-11-08 12AM"
        }
      ],
      "month": [
        {
          "volume": 24007,
          "time": "8th Nov"
        },
        {
          "volume": 790702,
          "time": "7th Nov"
        },
        {
          "volume": 33618,
          "time": "6th Nov"
        },
        {
          "volume": 49502,
          "time": "5th Nov"
        },
        {
          "volume": 46656,
          "time": "4th Nov"
        },
        {
          "volume": 46237,
          "time": "3rd Nov"
        },
        {
          "volume": 46325,
          "time": "2nd Nov"
        },
        {
          "volume": 40467,
          "time": "1st Nov"
        }
      ],
      "Year": [
        {
          "volume": 1077518,
          "time": "November"
        },
        {
          "volume": 1368055,
          "time": "October"
        },
        {
          "volume": 1340407,
          "time": "September"
        },
        {
          "volume": 1154907,
          "time": "August"
        },
        {
          "volume": 421196744,
          "time": "July"
        },
        {
          "volume": 1364035807,
          "time": "June"
        },
        {
          "volume": 2000166,
          "time": "May"
        },
        {
          "volume": 413721,
          "time": "April"
        },
        {
          "volume": 6817,
          "time": "March"
        }
      ]
    },
    powerFactorChart: {
      "day": [
        {
          "volume": "0.000",
          "time": "2022-11-08 4PM"
        },
        {
          "volume": "0.979",
          "time": "2022-11-08 3PM"
        },
        {
          "volume": "0.973",
          "time": "2022-11-08 2PM"
        },
        {
          "volume": "0.980",
          "time": "2022-11-08 1PM"
        },
        {
          "volume": "0.810",
          "time": "2022-11-08 12PM"
        },
        {
          "volume": "0.977",
          "time": "2022-11-08 11AM"
        },
        {
          "volume": "0.966",
          "time": "2022-11-08 10AM"
        },
        {
          "volume": "0.996",
          "time": "2022-11-08 9AM"
        },
        {
          "volume": "0.954",
          "time": "2022-11-08 8AM"
        },
        {
          "volume": "0.984",
          "time": "2022-11-08 7AM"
        },
        {
          "volume": "0.982",
          "time": "2022-11-08 6AM"
        },
        {
          "volume": "0.980",
          "time": "2022-11-08 5AM"
        },
        {
          "volume": "0.984",
          "time": "2022-11-08 4AM"
        },
        {
          "volume": "0.993",
          "time": "2022-11-08 3AM"
        },
        {
          "volume": "0.973",
          "time": "2022-11-08 2AM"
        },
        {
          "volume": "0.975",
          "time": "2022-11-08 1AM"
        },
        {
          "volume": "0.990",
          "time": "2022-11-08 12AM"
        }
      ],
      "month": [
        {
          "volume": "0.910",
          "time": "8th Nov"
        },
        {
          "volume": "0.650",
          "time": "7th Nov"
        },
        {
          "volume": "0.940",
          "time": "6th Nov"
        },
        {
          "volume": "0.970",
          "time": "5th Nov"
        },
        {
          "volume": "0.970",
          "time": "4th Nov"
        },
        {
          "volume": "0.370",
          "time": "3rd Nov"
        },
        {
          "volume": "0.690",
          "time": "2nd Nov"
        },
        {
          "volume": "0.800",
          "time": "1st Nov"
        }
      ],
      "Year": [
        {
          "volume": "0.760",
          "time": "November"
        },
        {
          "volume": "0.650",
          "time": "October"
        },
        {
          "volume": "0.910",
          "time": "September"
        },
        {
          "volume": "0.930",
          "time": "August"
        },
        {
          "volume": "0.440",
          "time": "July"
        },
        {
          "volume": "0.000",
          "time": "June"
        },
        {
          "volume": "0.930",
          "time": "May"
        },
        {
          "volume": "0.860",
          "time": "April"
        },
        {
          "volume": "0.950",
          "time": "March"
        }
      ]
    },
    lineChartOptions: {
      maintainAspectRatio: false,
      responsive: true,
      legend: {
        position: "bottom",
      },
    },
    chart_Data_outside: {
      datasets: [
        {
          data: [],
          label: "Temperature ( °C )",
          borderWidth: 1.5,
          backgroundColor: "rgba(172, 0, 252,.1)",
          borderColor: "rgba(172, 0, 252,.9)",
          //     backgroundColor:  this.gradient,
        },
        {
          data: [],
          label: "Humid ( % )",
          backgroundColor: "rgba(20, 153, 242,.1)",
          borderWidth: 1.5,
          borderColor: "rgba(20, 153, 242,.9)",

          //     backgroundColor:  this.gradient,
        },
      ],
      labels: [],
    },
    // options_Chart: {
    //   maintainAspectRatio: false,
    //   responsive: true,
    //   legend: {
    //     position: "bottom",
    //   },
    // },
    pages3: [{ text: "Page 1" }, { text: "Page 2" }, { text: "Page 3" }],
    popupActivo4: false,
    checkBox1: "",
    primeFilter: [],
    currentFilter: "",
    descriptionItems: [3, 5, 15],
    select1: "",
    selectLocation: [],
    selectHeightMap: [],
    selectAreaMap: [],
    selectDevice: [],
    idDeviceList: [],
    device: [],
    optionsMap: [
      { text: "Default" },
      { text: "Inside" },
      { text: "Outside" },
      { text: "Custom" },
    ],
    optionsMap2: [{ text: "Inside" }, { text: "Outside" }],
    optionsHeight: [
      { text: "All", value: "" },
      { text: "2m", value: "2m" },
      { text: "6m", value: "6m" },
      { text: "10m", value: "10m" },
      { text: "12m", value: "12m" },
    ],
    optionsHeight2: [
      // { text: "All", value: "" },
      { text: "2m", value: "2m" },
      { text: "6m", value: "6m" },
      { text: "10m", value: "10m" },
      { text: "12m", value: "12m" },
    ],
    optionsHeightOutside: [{ text: "Left" }, { text: "Right" }],
    optionsID: [
      { text: "6 meters", value: "6m" },
      { text: "2 meters", value: "2m" },
    ],
    sensorList: [],
    iconMap: [],
    iconMapChart: [],
    fields: [
      { key: "date", label: "Timestamp", visible: true },
      { key: "id", label: "Device No.", visible: true },
      { key: "temperature", label: "Temperature (°C)", visible: true },
      { key: "humidity", label: "Humidity", visible: true },
      { key: "location", label: "Location", visible: true },
      { key: "height", label: "Height", visible: true },
      { key: "color", label: "Battery", visible: true },
    ],
    optionsColor: [
      { text: "Red", icon: ">", color: "textDanger", value2: "" },
      {
        text: "Yellow",
        icon: "-",
        color: "textYellow",
        value1: "",
        value2: "",
      },
      {
        text: "Green",
        icon: "-",
        color: "colorSuccess",
        value1: "",
        value2: "",
      },
      { text: "Blue", icon: "<", color: "textBlue", value2: 21 },
    ],
    headerList: [
      { text: "Timestamp", visible: true },
      { text: "Device No.", visible: true },
      { text: "Temperature (°C)", visible: true },
      { text: "Humidity", visible: true },
      { text: "Location", visible: true },
      { text: "Hight", visible: true },
      { text: "Battery", visible: true },
    ],
    lo: [],
    arraylo: [],
    averageTemp: [],
    test: [],
    insidetem: 0,
    insidehum: 0,
    outsidetem: 0,
    outsidehum: 0,
    datetime: "",
    time: "",
    selectHeight: [],
    selectSide: [],
    optionsSide: [
      { text: "left", value: "left" },
      { text: "right", value: "right" },
    ],
    headerList: [
      "Timestamp",
      "Device No.",
      "Temperature",
      "Humidity",
      "Location",
      "Hight",
      "Battery",
    ],
    users: [],
    btnHeigth: "",

    ////P
    headerchart: [],
    datachart: [],
    datachartout: [],
    datachart2: [],
    datachart2out: [],
    datachartfillint: [],
    datachartfillinh: [],
    datachartfilloutt: [],
    datachartfillouth: [],
    insidefiltem: 0,
    insidefilhum: 0,
    outsidefiltem: 0,
    outsidefilhum: 0,
    insidefil: 0,
    outsidefil: 0,
    inmin: 0,
    inmax: 0,
    outmin: 0,
    outmax: 0,
    interval: null,
    users: [],
    default_map: [],
    groupedByHour: ([] = []),
    prefixAPI: 'awc/'
  }),
  // beforeCreate() {
  //   this.$API.get(`awc/gateways`)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         const { data } = res
  //         if (data && data.length > 0) this.id = data[0].id
  //       }
  //     })
  // },
  async mounted() {
    this.getGateways()
    this.callapi();
    this.getMapsetting();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  methods: {
    async getGateways() {
      try {
        const res = await this.$API.get(`awc/gateways`)
        this.id = res.data[0].id
      } catch (error) {
        console.error('Error! Could not reach the API. ' + error)
      }
    },
    mappingData(data, pattern = 'day') {
      var response = []
      if (data && data.length > 0) {
        data.reverse()
        switch (pattern) {
          case 'day':
            data = data.filter((d) => d[0].search('00:00') > -1)
            response = data.map((d) => ({
              time: moment(d[0]).format('YYYY-MM-DD hA'),
              volume: d[1]
            }))
            break;
          case 'month':
            data = data.filter((d) => d[0].search('00:00:00') > -1)
            response = data.map((d) => ({
              time: moment(d[0]).format('M/D'),
              volume: d[1]
            }))
            break;
          case 'year':
            response = data.map((d) => ({
              time: moment(d[0]).format('YYYY MM'),
              volume: d[1]
            }))
            break;
          default:
            break;
        }
      }

      // console.log('TEST.MappingData', data, pattern, response)

      return response
    },
    async getGatewayById() {
      await this.$API.get(`awc/gateway/${this.id}/data`)
        .then((res) => {
          if (res.status === 200) {
            const { data } = res
            console.log('TEST.response', data)

            var totalPowerConsumption = { ...this.datas.totalPowerConsumption }

            if (data.total_power_consumption) {
              const { total_power_consumption } = data
              totalPowerConsumption = {
                ...totalPowerConsumption,
                dailyVolume: total_power_consumption.day,
                dailyPeak: total_power_consumption.daily_peak,
                monthVolume: total_power_consumption.month,
                yearVolume: total_power_consumption.year,
                total: total_power_consumption.total || 0,
              }
            }

            var powerFactor = {}
            if (data.power_factor && data.power_factor.power_factor && data.power_factor.power_factor.length > 0) {
              powerFactor.day = this.mappingData(data.power_factor.power_factor, 'day')
              powerFactor.month = this.mappingData(data.power_factor.power_factor, 'month')
              powerFactor.year = this.mappingData(data.power_factor.power_factor, 'year')

              this.datas.powerConsumptionActive = data.power_factor.power_factor[data.power_factor.power_factor.length - 1][1]
              totalPowerConsumption.dailyPF = this.datas.powerConsumptionActive
            }
            // console.log('TEST.powerFactor', powerFactor)

            var powerVolume = {}
            if (data.power_volume && data.power_volume.power_consumption && data.power_volume.power_consumption.length > 0) {
              powerVolume.day = this.mappingData(data.power_volume.power_consumption, 'day')
              powerVolume.month = this.mappingData(data.power_volume.power_consumption, 'month')
              powerVolume.year = this.mappingData(data.power_volume.power_consumption, 'year')

              // this.datas.powerConsumptionTotal = data.power_volume.power_consumption[0][1]
            }
            // console.log('TEST.powerVolume', powerVolume)

            var powerConsumption = {}
            if (data.power_consumption_graph && data.power_consumption_graph.power_consumption && data.power_consumption_graph.power_consumption.length > 0) {
              powerConsumption.month = this.mappingData(data.power_consumption_graph.power_consumption, 'month')
              powerConsumption.year = this.mappingData(data.power_consumption_graph.power_consumption, 'year')

              // this.datas.totalPowerConsumption.total = data.power_consumption_graph.power_consumption[data.power_consumption_graph.power_consumption.length - 1][1]
            }
            // console.log('TEST.powerConsumption', powerConsumption)

            var electricPotentialGraph = data.electric_potentail_graph
            var _electricPotential = data.electric_potentail
            var electricPotential = []
            if (_electricPotential) {
              if (_electricPotential.current1 && _electricPotential.vol1_2)
                electricPotential.push({ key: 1, current: _electricPotential.current1, volume: _electricPotential.vol1_2 })
              if (_electricPotential.current2 && _electricPotential.vol2_3)
                electricPotential.push({ key: 2, current: _electricPotential.current2, volume: _electricPotential.vol2_3 })
              if (_electricPotential.current3 && _electricPotential.vol3_1)
                electricPotential.push({ key: 3, current: _electricPotential.current3, volume: _electricPotential.vol3_1 })
            }

            this.datas = { ...this.datas, powerFactor, powerVolume, powerConsumption, electricPotentialGraph, electricPotential, totalPowerConsumption }
          }
        })
    },


    async getMapsetting() {
      try {
        await this.$API.get(`dashboard/config/map/1`).then((result) => {
          this.test = result.data;
          // console.log(result.data);
          this.optionsColor[0].value2 = result.data[0].red;
          this.optionsColor[1].value1 = result.data[0].yellow[0];
          this.optionsColor[1].value2 = result.data[0].yellow[1];
          this.optionsColor[2].value1 = result.data[0].green[0];
          this.optionsColor[2].value2 = result.data[0].green[1];
          this.optionsColor[3].value2 = result.data[0].blue;
          this.select1 = result.data[0].device_location;
          this.selectHeightMap = result.data[0].device_height;
          this.selectDevice = result.data[0].device;
          this.selectLocation = result.data[0].select_location;
          this.selectAreaMap = result.data[0].device_area_map;
          this.btnHeigth = result.data[0].height;
        });
      } catch (error) {
        console.log(error);
      }
    },
    async callapi() {
      try {
        var text = 0;
        var count = 0;
        // this.openLoadingInDiv();
        const average = (arr) => arr.reduce((p, c) => p + c, 0) / arr.length;
        let result = await this.$API.get(`sensor/network/115/frasers`);
        this.Allside_avg(result.data);
        result.data.forEach(async (element) => {
          this.idDeviceList.push({
            id: element.id,
          });
          if (element.location != "Outside") {
            let filteredData = result.data.filter(
              (data) => data.location == element.location
            );
            element.avgTemp = (
              filteredData.reduce(
                (total, next) => total + next.temperature,
                0
              ) / filteredData.length
            ).toFixed(1);
            element.avgHumd = (
              filteredData.reduce((total, next) => total + next.humidity, 0) /
              filteredData.length
            ).toFixed(1);
            element.nameTempA = element.temperature;
            //compute temperature&humdity by location
            element.selectLocationTemp = [];
            element.selectLocationHumd = [];
            await filteredData.forEach((data) => {
              element.selectLocationTemp.push(
                data.name + " Temperature : " + data.temperature + "°C \n"
              );
              element.selectLocationHumd.push(data.humidity);
            });
          } else {
            element.avgTemp = element.temperature.toFixed(1);
          }
        });
        // console.log(result.data);
        this.iconMap = result.data;
        result = await this.$API.get(`sensor/indoor/frasers`);
        result.data.forEach((element) => {
          this.idDeviceList.push({
            id: element.id,
          });
          if (element.location != "Outside") {
            let filteredData = result.data.filter(
              (data) => data.location == element.location
            );
            element.avgTemp = (
              filteredData.reduce(
                (total, next) => total + next.temperature,
                0
              ) / filteredData.length
            ).toFixed(1);
            element.avgHumd = (
              filteredData.reduce((total, next) => total + next.humidity, 0) /
              filteredData.length
            ).toFixed(1);
            element.nameTempA = element.temperature;
          } else {
            element.avgTemp = element.temperature.toFixed(1);
          }
        });
        console.log(result.data);
        this.iconMapChart = result.data;

        // await this.$API.get("sensor/network/115/frasers").then((res) => {
        //   this.Allside_avg(res.data);
        //   const datenow = moment().format();
        //   this.datetime = datenow.split("T");
        //   const timechange = this.datetime[1];
        //   this.time = timechange.split("+");
        //   this.allsidefilter_avg(this.filteredListChart);
        //   this.fetchChartfilter(this.filteredListChart);
        // });

        const datenow = moment().format();
        this.datetime = datenow.split("T");
        const timechange = this.datetime[1];
        this.time = timechange.split("+");
        this.allsidefilter_avg(this.filteredListChart);
        this.fetchChartfilter(this.filteredListChart);
      } catch (error) {
        console.log(error);
      }
      this.interval = setTimeout(() => {
        this.callapi();
      }, 1000 * 60);
    },
    openLoadingInDiv() {
      this.$vs.loading({
        scale: 1,
        type: "radius",
      });
      setTimeout(() => {
        this.$vs.loading.close();
      }, 2200);
    },
    fetchChartfilter(data) {
      const timedd = [];
      data.forEach((sensordata) => {
        const date = sensordata.timestamp;
        this.date = moment(date).format("hh A");
        timedd.push(this.date);
      });
      this.timedd2 = [...new Set(timedd)];
      this.headerchart = this.timedd2;
      this.groupedByHour = data.reduce((result, item) => {
        let hour = moment(item.timestamp).format("hh A");
        result[hour] = result[hour] || [];
        result[hour].push(item);
        return result;
      }, []);

      var tempIn = 0;
      var humpIn = 0;
      var tempOut = 0;
      var humpOut = 0;
      var dataSumtemp = [];
      var dataSumhump = [];
      var dataSumtempout = [];
      var dataSumhumpout = [];
      for (var i = 0; i < Object.values(this.groupedByHour).length; i++) {
        var j = 0;
        var k = 0;
        Object.values(this.groupedByHour)[i].forEach((e, i) => {
          if (e.type == "Inside") {
            tempIn += e.data.temperature;
            humpIn += e.data.humidity;
            j++;
          } else if (e.type == "Outside") {
            tempOut += e.data.temperature;
            humpOut += e.data.humidity;
            k++;
          }
        });
        tempIn = tempIn / j;
        humpIn = humpIn / j;
        tempOut = tempOut / k;
        humpOut = humpOut / k;
        tempIn = parseFloat(tempIn.toFixed(1));
        humpIn = parseFloat(humpIn.toFixed(1));
        tempOut = parseFloat(tempOut.toFixed(1));
        humpOut = parseFloat(humpOut.toFixed(1));
        dataSumtemp.push(tempIn);
        dataSumhump.push(humpIn);
        dataSumtempout.push(tempOut);
        dataSumhumpout.push(humpOut);
        humpIn = 0;
        tempIn = 0;
        humpOut = 0;
        tempOut = 0;
      }
      const data2 = dataSumtemp;
      const data3 = dataSumhump;
      const data4 = dataSumtempout;
      const data5 = dataSumhumpout;
      this.datachartfillint = data2;
      this.datachartfillinh = data3;
      this.datachartfilloutt = data4;
      this.datachartfillouth = data5;
      this.chart_Data_inside.labels = this.headerchart;
      this.chart_Data_inside.datasets[0].data = this.datachartfillint;
      this.chart_Data_inside.datasets[1].data = this.datachartfillinh;
      this.chart_Data_outside.labels = this.headerchart;
      this.chart_Data_outside.datasets[0].data = this.datachartfilloutt;
      this.chart_Data_outside.datasets[1].data = this.datachartfillouth;
    },
    search(btn) {
      let data = this.primeFilter.filter((element) => element.height == btn);
      this.btnHeigth = btn;
    },
    Allside_avg(amout) {
      // console.log(amout);
      this.insidetem = 0;
      this.insidehum = 0;
      this.outsidetem = 0;
      this.outsidehum = 0;
      var inside = 0;
      var outside = 0;
      amout.forEach((users) => {
        if (users.type === "Inside") {
          this.insidetem += users.temperature;
          this.insidehum += users.humidity;
          inside++;
        } else if (users.type === "Outside") {
          this.outsidetem += users.temperature;
          this.outsidehum += users.humidity;
          outside++;
        }
      });
      this.outsidetem = this.outsidetem / outside;
      this.outsidetem = this.Decimalavg(this.outsidetem);
      this.outsidehum = this.outsidehum / outside;
      this.outsidehum = this.Decimalavg(this.outsidehum);
      this.insidetem = this.insidetem / inside;
      this.insidetem = this.Decimalavg(this.insidetem);
      this.insidehum = this.insidehum / inside;
      this.insidehum = this.Decimalavg(this.insidehum);
    },
    allsidefilter_avg(amout, datachart) {
      this.insidefiltem = 0;
      this.insidefilhum = 0;
      this.outsidefiltem = 0;
      this.outsidefilhum = 0;
      this.insidefil = 0;
      this.outsidefil = 0;
      this.inmin = 0;
      this.inmax = 0;
      this.outmin = 0;
      this.outmax = 0;
      const inminmax = [];
      const outminmax = [];
      const ArrayList = amout;
      ArrayList.forEach((filteredList) => {
        if (filteredList.type === "Inside") {
          this.insidefiltem += filteredList.temperature;
          this.insidefilhum += filteredList.humidity;
          this.insidefil++;
          inminmax.push(filteredList.temperature);
        } else if (filteredList.type === "Outside") {
          this.outsidefiltem += filteredList.temperature;
          this.outsidefilhum += filteredList.humidity;
          this.outsidefil++;
          outminmax.push(filteredList.temperature);
        }
      });
      if (this.insidefil != 0) {
        this.inmin = Math.min(...inminmax).toFixed(1);
        this.inmax = Math.max(...inminmax).toFixed(1);
        this.insidefiltem = this.insidefiltem / this.insidefil;
        this.insidefiltem = this.Decimalavg(this.insidefiltem);
        this.insidefilhum = this.insidefilhum / this.insidefil;
        this.insidefilhum = this.Decimalavg(this.insidefilhum);
      }
      if (this.outsidefil != 0) {
        this.outmin = Math.min(...outminmax).toFixed(1);
        this.outmax = Math.max(...outminmax).toFixed(1);
        this.outsidefiltem = this.outsidefiltem / this.outsidefil;
        this.outsidefiltem = this.Decimalavg(this.outsidefiltem);
        this.outsidefilhum = this.outsidefilhum / this.outsidefil;
        this.outsidefilhum = this.Decimalavg(this.outsidefilhum);
      }
    },
    Decimalavg(amout) {
      return amout.toFixed(1);
    },
    link2(item) {
      console.log(item);
      this.$session.set("deviceList", item);
      this.$router.push({
        name: "SensorList",
        params: {
          deviceList: item,
        },
      });
    },
    check(e) {
      console.log(e);
    },
    cancelMapsetting() {
      this.popupActivo4 = false;
      this.getMapsetting();
      // this.reload()
    },
    saveMapsetting(
      item,
      select,
      selectHeight,
      selectDevice,
      selectAreaMap,
      selectLocation,
      filteredList,
      selectHeigth2
    ) {
      var body = {
        red: [parseFloat(item[0].value2[0])],
        yellow: [parseFloat(item[1].value1), parseFloat(item[1].value2)],
        green: [parseFloat(item[2].value1), parseFloat(item[2].value2)],
        blue: [parseFloat(item[3].value2[0])],
        deviceLocation: select,
        deviceHight: this.selectHeightMap,
        device: selectDevice,
        deviceAreaMap: selectAreaMap,
        selectLocation: selectLocation,
        selectHeigth: selectHeigth2,
      };
      console.log(body);
      this.$API
        .put(`dashboard/config/map/1`, body)
        .then((result) => {
          console.log(result.data);
          if (result.status == 200)
            this.$vs.notify({
              title: "Work Order Updated",
              text: "Your work order has been updated",
              color: "primary",
              position: "top-center",
            });
          setTimeout(() => {
            this.$refs["settingMap"].hide();
            this.popupActivo4 = false;
            location.reload();
          }, 1500);
        })
        .catch((err) => {
          if (err.response.status == 500)
            this.$vs.notify({
              title: "Invalid",
              text: "Please try again",
              color: "warning",
              position: "top-center",
            });
        });
      this.allsidefilter_avg(filteredListChart);
      this.fetchChartfilter(filteredListChart);
      location.reload();
    },
    calculateTemp(temp) { },
  },
  computed: {
    StockChartCom() {
      this.datas.electricPotentialChart.series = [
        {
          name: "Phase 1",
          data: this.datas.electricPotentialGraph.vol1_2,
          tooltip: {
            valueDecimals: 2,
          },
        },
        {
          name: "Phase 2",
          data: this.datas.electricPotentialGraph.vol2_3,
          tooltip: {
            valueDecimals: 2,
          },
        },
        {
          name: "Phase 3",
          data: this.datas.electricPotentialGraph.vol3_1,
          tooltip: {
            valueDecimals: 2,
          },
        },
      ];

      // console.log('StockChartCom.response', this.datas.electricPotentialGraph)

      return this.datas.electricPotentialChart;
    },
    filteredList() {
      if (this.select1 == "Default") {
        return this.iconMap;
      } else if (this.select1 == "Custom") {
        if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length == 0
        ) {
          this.primeFilter = this.iconMap;
        } else if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length != 0
        ) {
          this.primeFilter = this.iconMap.filter((post) => {
            if (this.selectHeightMap.includes(post.height)) return post;
          });
        } else if (
          this.selectLocation.length != 0 &&
          this.selectHeightMap.length == 0
        ) {
          if (this.selectAreaMap.length == 0) {
            this.primeFilter = this.iconMap.filter((post) => {
              if (this.selectLocation.includes(post.type)) return post;
            });
          } else {
            this.primeFilter = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectAreaMap.includes(post.height)) return post;
              });
          }
        } else {
          if (this.selectLocation == "Inside") {
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectHeightMap.includes(post.height)) return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else if (this.selectLocation == "Outside") {
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (this.selectAreaMap.includes(post.height)) return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else {
            let tempArray = this.selectHeightMap.concat(this.selectAreaMap);
            let temp = this.iconMap
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (tempArray.includes(post.height)) return post;
              });
            this.primeFilter = temp;
          }
        }
      } else {
        this.currentFilter = this.select1;
        this.primeFilter = this.iconMap.filter((post) => {
          return post.type
            .toString()
            .toLowerCase()
            .includes(this.select1.toLowerCase());
        });
        // ตรงนี้
        try {
          if (this.btnHeigth.length != 0 && this.select1 == "Inside")
            this.primeFilter = this.primeFilter.filter(
              (element) => element.height == this.btnHeigth
            );
          return this.primeFilter;
        } catch (error) {
          return this.primeFilter;
        }
      }
      // if (this.btnHeigth.length != 0)
      //   this.primeFilter = this.primeFilter.filter(
      //     (element) => element.height == this.btnHeigth
      //   );

      if (this.selectDevice.length != 0) {
        let displayDevice = this.primeFilter.filter((post) => {
          if (this.selectDevice.includes(post.id)) return post;
        });

        displayDevice.forEach((element) => {
          let filteredData = displayDevice.filter(
            (data) => data.class == element.class
          );
          if (filteredData.length == 1) {
            element.avgTemp = element.temperature;
            element.selectLocationTemp =
              element.name + " Temperature : " + element.temperature + "°C \n";

            element.avgHumd = element.humidity;
          }
        });
        if (this.btnHeigth.length != 0 && this.select1 != "Custom")
          displayDevice = displayDevice.filter(
            (element) => element.height == this.btnHeigth
          );
        return displayDevice;
      } else if (this.selectDevice.length == 0) return this.primeFilter;
    },
    filteredListChart() {
      if (this.select1 == "Default") {
        return this.iconMapChart;
      } else if (this.select1 == "Custom") {
        if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length == 0
        ) {
          this.primeFilter = this.iconMapChart;
        } else if (
          this.selectLocation.length == 0 &&
          this.selectHeightMap.length != 0
        ) {
          this.primeFilter = this.iconMapChart.filter((post) => {
            if (
              this.selectHeightMap.includes(post.height) ||
              post.type == "Outside"
            )
              return post;
          });
        } else if (
          this.selectLocation.length != 0 &&
          this.selectHeightMap.length == 0
        ) {
          if (this.selectAreaMap.length == 0) {
            this.primeFilter = this.iconMapChart.filter((post) => {
              if (
                this.selectLocation.includes(post.type) ||
                post.type == "Inside"
              )
                return post;
            });
          } else {
            this.primeFilter = this.iconMapChart.filter((post) => {
              if (
                this.selectAreaMap.includes(post.height) ||
                post.type == "Inside"
              )
                return post;
            });
          }
        } else {
          if (this.selectLocation == "Inside") {
            let temp = this.iconMapChart
              .filter((post) => {
                if (
                  this.selectLocation.includes(post.type) ||
                  post.type == "Outside"
                )
                  return post;
              })
              .filter((post) => {
                if (
                  this.selectHeightMap.includes(post.height) ||
                  post.type == "Outside"
                )
                  return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else if (this.selectLocation == "Outside") {
            let temp = this.iconMapChart
              .filter((post) => {
                if (
                  this.selectLocation.includes(post.type) ||
                  post.type == "Inside"
                )
                  return post;
              })
              .filter((post) => {
                if (
                  this.selectAreaMap.includes(post.height) ||
                  post.type == "Inside"
                )
                  return post;
              });
            this.primeFilter = temp;
            this.calculateTemp(this.primeFilter);
          } else {
            let tempArray = this.selectHeightMap.concat(this.selectAreaMap);
            let temp = this.iconMapChart
              .filter((post) => {
                if (this.selectLocation.includes(post.type)) return post;
              })
              .filter((post) => {
                if (tempArray.includes(post.height)) return post;
              });
            this.primeFilter = temp;
          }
        }
      } //Inside/Outside
      else {
        this.currentFilter = this.select1;
        var chartData = this.iconMapChart;
        if (this.btnHeigth.length != 0 && this.select1 == "Inside")
          return chartData.filter(
            (element) =>
              element.height == this.btnHeigth || element.type == "Outside"
          );
        else if (this.btnHeigth.length != 0 && this.select1 == "Outside")
          return chartData.filter(
            (element) =>
              element.height == this.btnHeigth || element.type == "Inside"
          );
        else return chartData;
        // return chartData
        // else if (this.btnHeigth.length != 0 && this.select1 == "Outside") chartData = chartData.filter((element) => {
        //   if(element.height == this.btnHeigth || element.type == 'Inside') return chartData
        // })
        // else return chartData;
      }

      // if (this.btnHeigth.length != 0)
      //   this.primeFilter = this.primeFilter.filter(
      //     (element) => element.height == this.btnHeigth
      //   );

      if (this.selectDevice.length != 0) {
        let displayDevice = this.primeFilter.filter((post) => {
          if (this.selectDevice.includes(post.id)) return post;
        });

        displayDevice.forEach((element) => {
          let filteredData = displayDevice.filter(
            (data) => data.class == element.class
          );
          if (filteredData.length == 1) {
            element.avgTemp = element.temperature;
            // element.selectLocationTemp = element.temperature;
            element.avgHumd = element.humidity;
          }
        });
        if (this.btnHeigth.length != 0 && this.select1 != "Custom")
          displayDevice = displayDevice.filter(
            (element) => element.height == this.btnHeigth
          );
        return displayDevice;
      } else if (this.selectDevice.length == 0) return this.primeFilter;
    },
    filterSelectDevice() {
      return this.primeFilter;
    },
    filterHeight() {
      this.primeFilter = this.primeFilter.filter((post) => {
        if (this.selectHeightMap.includes(post.height)) return post;
      });
      return this.primeFilter;
    },
    filterLocation() {
      this.primeFilter = this.iconMapChart.filter((post) => {
        return post.type
          .toString()
          .toLowerCase()
          .includes(this.select1.toLowerCase());
      });
      return this.primeFilter;
    },
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    }
  },
  watch: {
    id(newId, oldId) {
      if (newId !== oldId)
        this.getGatewayById()
    },
    datas(newData, oldData) {
      console.log('TEST.watch.datas', newData, oldData)
    }
  }
};
</script>
<style scoped>
.card-title-value {
  margin-bottom: 80px;
  font-size: 56px;
  line-height: 56px;
}

.card-title-value span {
  font-size: 30px;
}

.card-volume-1 {
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 40px;
}

.card-volume-1>span {
  font-size: 32px;
}

.card-volume-2 {
  font-size: 18px;
  line-height: 18px;
  margin-bottom: 20px;
}

.card-volume-2>span {
  font-size: 24px;
}

.card-date {
  position: absolute;
  right: 30px;
  bottom: 15px;
  font-size: 16px;
  line-height: 16px;
  text-decoration: underline;
}

.list-none {
  list-style: none;
}

.textlist2 {
  /* background: linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%); */
  border-radius: 20px;
  padding: 8px 5px 5px;
  font-weight: 600;
  margin: 0 20%;
}

.gradient1 {
  background: linear-gradient(90deg,
      rgb(247, 141, 84) 0%,
      rgb(245, 185, 82) 100%);
  /* font-weight: 500; */
}

.gradient2 {
  background: linear-gradient(90deg, #77d8f3 0%, #92fe9d 100%);
  /* font-weight: 500; */
}

.gradient3 {
  background: linear-gradient(90deg, #fa7ba5 0%, #f3c86b 100%);
  /* font-weight: 500; */
}

.txttemp {
  color: #fc8200;
  font-weight: 300;
}

.txthum {
  color: #2ba0ff;
  font-weight: 300;
}

.txtsize {
  font-size: 3.4vh;
}

.img-bg {
  padding: 0;
  /* background-image: url("../../../assets/images/frasers/bg/KhonKaen.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover; */
}

.btnGroupH {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #f8f9fa;
  border: 1px solid #212529;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.45;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.roundedCard {
  border-radius: 20px;
  background-color: #fff;
}

.imgMapFreacer {
  max-width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.vl {
  border-left: 2px solid rgb(197, 197, 197);
  height: 50;
}

.roundedCard {
  border-radius: 20px;
}

.imgMapFreacer {
  max-width: 90%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.cursor-pointer {
  cursor: pointer;
}

.brdbtn {
  width: 80px;
  border-radius: 20px;
}

.img-wraps {
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.img-wraps .Right {
  position: absolute;
  top: 8%;
  right: 7%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}

.img-wraps .B1 {
  position: absolute;
  top: 24.5%;
  right: 7%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  /* font-size: 22px; */
  /* border-radius: 20px; */
  /* background: #ffffff; */
  line-height: 10px;
}

.img-wraps .D3 {
  position: absolute;
  top: 44.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .D5 {
  position: absolute;
  top: 44.5%;
  right: 48.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .D6 {
  position: absolute;
  top: 44.5%;
  right: 59%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .B3 {
  position: absolute;
  top: 24.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .B4 {
  position: absolute;
  top: 24.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .B6 {
  position: absolute;
  top: 24.5%;
  right: 59%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .B5 {
  position: absolute;
  top: 24.5%;
  right: 48.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .F3 {
  position: absolute;
  top: 65.5%;
  right: 28%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .F5 {
  position: absolute;
  top: 65.5%;
  right: 48.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .F6 {
  position: absolute;
  top: 65.5%;
  right: 59.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .B7 {
  position: absolute;
  top: 24.5%;
  right: 69.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .Left {
  position: absolute;
  top: 8%;
  right: 69.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
  .txtsize {
    font-size: 1.2vh;
  }
}

/* Portrait and Landscape */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .txtsize {
    font-size: 1.2vh;
  }
}

.con-vs-card.card-inline {
  display: inline-block;
  width: auto;
}

.map-temperature {
  font-size: 0.8rem;
  position: absolute;
  font-weight: 400;
  width: 100%;
  top: 36%;
  color: white;
  right: 2%;
}

p.card-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

p.card-value {
  font-size: 2.5rem;
  margin-bottom: 0;
  color: #48c93b;
}

.card-total-customized {
  padding: 99px 0;
}

div.simple-box {
  height: 173px;
  display: flex;
}

div.simple-box>div {
  flex: 1;
  align-self: center;
}
</style>